import { SVGProps } from "react";

export const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      fill="var(--start-color, #000)"
      d="M12 1.714C6.32 1.714 1.714 6.32 1.714 12c0 1.856.49 3.594 1.349 5.096a.857.857 0 0 1 .08.66L1.91 22.092l4.338-1.234a.858.858 0 0 1 .66.08c1.55.886 3.306 1.35 5.092 1.348 5.681 0 10.286-4.606 10.286-10.286S17.68 1.714 12 1.714ZM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12c-2.03 0-3.945-.505-5.623-1.396L1.64 23.95A1.285 1.285 0 0 1 .05 22.363L1.4 17.625A11.949 11.949 0 0 1 0 12Zm6.857-2.571a.857.857 0 0 1 .857-.858h8.572a.857.857 0 1 1 0 1.715H7.714a.857.857 0 0 1-.857-.857Zm.857 4.285a.857.857 0 0 0 0 1.715h5.143a.857.857 0 1 0 0-1.715H7.714Z"
    />
  </svg>
);
